<template>
  <div class="contentbox" v-if="webConfig">
    <!-- <div class="logo">
        <img src="/static/img/logo2.png" alt="" @click="$router.push('/')">
    </div> -->
    <div class="header">
      <div class="headerbox">
        <img :src="`${IP_TEST}/uploads/${webConfig.logopic}`" alt="" @click="$router.push('/')">
        <div class="back">
            <a class="light" href="/inquery">继续查询</a>
            <a href="/">返回页面</a>
        </div>
      
      </div>
    
    </div>
    <div class="result">
      <h2>查询结果页</h2>
      <!-- <div>根据中国专家智库网人才入库审核标准，经评定！信息符合职业技术人才入库审核标准，同意您加入专家智库。</div> -->
    </div>
    <div class="show" v-if="showInfo">
      <div class="personBox">
        <h1>
          人员基本信息 
        </h1>
        <!-- <a href="/" class="back">返回主页</a> -->
          <table  class="personInfo">
            <tr>
              <td v-if="!(showInfo.certtypename=='专业能力类'||showInfo.certtypename=='职业能力等级类'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书')" rowspan="4" style="padding:15px;width:200px">
              <img :src="`/uploads/xlsfile/usepic/${showInfo.picsrc}`" alt="">
            </td>
              <td v-if="showInfo.certtypename=='专业能力类'||showInfo.certtypename=='职业能力等级类'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书'">姓名</td>
              <td>{{ showInfo.name }}</td>
            </tr>
            <tr>
              <td v-if="showInfo.certtypename=='专业能力类'||showInfo.certtypename=='职业能力等级类'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书'">性别</td>
              <td>{{ showInfo.sex }}</td>
            </tr>
            <tr>
              <td v-if="showInfo.certtypename=='专业能力类'||showInfo.certtypename=='职业能力等级类'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书'">证件类型</td>
              <td>{{ showInfo.cardtype }}</td>
            </tr>
            <tr>
              <td v-if="showInfo.certtypename=='专业能力类'||showInfo.certtypename=='职业能力等级类'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书'">身份证号</td>
              <td>{{ showInfo.cardid }}</td>
            </tr>
            <tr>
              <td>出生日期</td>
              <td>{{ showInfo.birthday }}</td>
            </tr>
            <tr>
              <td>学历</td>
              <td>{{ showInfo.education }}</td>
            </tr>
            <tr>
              <td>工作单位</td>
              <td>{{ showInfo.danwei }}</td>
            </tr>
          </table>
          
      </div>
      <div  class="certBox">
        <h1>
          证书基本信息
        </h1>
        <table  class="personInfo">
          <tr>
            <td style="color: #999999;">证书类别</td>
            <td>{{ showInfo.certtypename }}</td>
          </tr>
          <tr>
            <td style="color: #999999;">证书编号</td>
            <td >{{ showInfo.code }}</td>
          </tr>
          <tr>
            <td style="color: #999999;">申报专业</td>
            <td >{{ showInfo.certname }}</td>
          </tr>
          <tr v-if="!(showInfo.certtypename=='专业能力类'||showInfo.certtypename=='职业能力等级类'||showInfo.certtypename=='紧缺人才入库证书'||showInfo.certtypename=='紧缺人才专业技能等级证书')">
            <td style="color: #999999;">专业方向</td>
            <td >{{ showInfo.majorfield }}</td>
          </tr>
          <tr>
            <td style="color: #999999;">考试成绩</td>
            <td>{{ showInfo.certscore }}</td>
          </tr>
          <tr>
            <td style="color: #999999;">申报级别</td>
            <td>{{ showInfo.certlevel }}</td>
          </tr>
          <tr>
            <td style="color: #999999;">发证日期</td>
            <td>{{ showInfo.certdate }}</td>
          </tr>
          <!-- <tr>
            <td style="color: #999999;">有效日期</td>
            <td>{{ formatExcelData(showInfo.valieddate) }}</td>
          </tr> -->
          <tr>
            <td style="color: #999999;">证书颁发机构</td>
            <td >{{ showInfo.regauth }}</td>
          </tr>
          <tr>
            <td style="color: #999999;">发证机构网址</td>
            <td>{{ showInfo.regurl }}</td>
          </tr>
        </table>
       
      </div>
      <div  class="certBox">
        <h1>
          继续教育记录
        </h1>
        <table class="personInfo">
          <div v-for="item in  pagenum" :key="item">
            <tr class="title">
              <td>{{ arrSprtQys[item-1]? arrSprtQys[item-1].title:''}}</td>
              <td>{{ arrSprtQys[item]? arrSprtQys[item].title:''}}</td>
            </tr>
            <tr class="date">
              <td>{{ arrSprtQys[item-1]? arrSprtQys[item-1].date:''}}</td>
              <td>{{ arrSprtQys[item]? arrSprtQys[item].date:''}}</td>
              
            </tr>
          </div>
        </table>
      </div>  
    </div>
  </div>

</template>

<script>
/**
 * 个人证书查询系统模版
 */
import { IP_TEST } from '@/config';
import QRCode from "qrcodejs2";
import { getFindAll } from '../../request/get'
export default {
  name: "ShowGr",
  data() {
    return {
      IP_TEST,
      arrSprtQys:[],
      pagenum:1,
      webConfig:null
    }
  },
  computed: {
  },
  created(){
    this.getFindAll();
    if(this.showInfo.nianjian)
    {
      let arrtmpsprts=this.showInfo.nianjian.split("##");
      for(let i = 0; i < arrtmpsprts.length;i++) {
        this.arrSprtQys[i]={
          title:arrtmpsprts[i].split("||")[0],
          date:arrtmpsprts[i].split("||")[1],
        }
      }
      this.pagenum = Math.ceil( this.arrSprtQys.length/2);
      if(this.pagenum===0)this.pagenum=1;
    }
  },
  props: {
    showInfo: Object
  },
    mounted() {
    console.log(this.$el);
	// this.creatQrCode(this.showInfo.cardid,this.showInfo.name,this.showInfo.bzcode,this.showInfo.certname);
  },
  methods: {
    async getFindAll() {
      let result = await getFindAll();
      result = result.data[0] || null;
      this.webConfig = result;
      this.$store.dispatch("SET_WEBCONFIG", result);
    },
    goHome() {
      this.$router.push("/");
    },
    formatExcelData(value) {
      let dataStr = this.formatExcel(value);
      if (isNaN(dataStr) && !isNaN(Date.parse(dataStr))) {
          value = new Date(dataStr);
          if (dataStr.indexOf("/") == -1 && dataStr.indexOf("-") == -1)
              value.setDate(value.getDate() + 1);
          value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
          -2
          )}月${("00" + value.getDate()).slice(-2)}日`;
          return value;
      } else {
          if (dataStr.indexOf("年") > -1) {
              var ttDate = dataStr.match(/\d{4}.\d{1,2}.\d{1,2}/gm).toString();
              ttDate = ttDate.replace(/[^0-9]/gm, "-");
              value = new Date(ttDate);
              value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
              return value;
          } else {
              if (!isNaN(dataStr)) {
                  var data = new Date(1900, 0, dataStr);
                  value = data;
                  value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
                  return value;
              } else {
                  return dataStr;
              }
          }
      }
  },
   formatExcel(value) {
      if (!value) {
          return "";
      } else {
          if (typeof value == "string") {
              return value.trim();
          } else {
              return value.toString().trim();
          }
      }
  },
  }
};
</script>
<style scoped>
.box{
  width: 100vw;
}
.contentbox{
  position: relative;
  width: 100vw;
  background-color: #EEF0F5;
  background-image: url(/static/img/img/beijign.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left bottom;
}
.contentbox .header{
  position: relative;
  width: 100vw;
  margin:0 auto;
height: auto;
background: #FFFFFF;
box-shadow: 0px 0.267vw 1.333vw 0px rgba(65,65,65,0.09);
}
.contentbox .headerbox{
  position: relative;
  padding: 3.333vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.headerbox img{
  width:26.4vw;
}
.headerbox .back{
  width: 41.867vw;
  height: 5.6vw;
border: 0.133vw solid #2F8EEC;
}
.headerbox a{
  display: inline-block;
  width: 20.93vw;
height: 5.6vw;
font-size: 2.4vw;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
line-height: 5.6vw;
text-align: center;
}
.headerbox a.light{
background: #2E8EEB;

color: #FFFFFF;
}
.personBox{
  color:#333333;
  font-size: 30px;
  width: 94vw;
height: 107.333vw;
background: linear-gradient(180deg, #FFFFFF, #C0D3F6);
border-radius: 2.667vw;
}
.certBox{
  color:#333333;
  font-size: 30px;
  margin-top: 4vw;
  width: 94vw;
  padding-bottom: 2.667vw;
min-height: 46.667vw;
background: linear-gradient(180deg, #FFFFFF, #C0D3F6);
border-radius: 2.667vw;
}
.logo{
    text-align: center;
    position: relative;
    top: 12px;
}
.logo img{
  width: 344px;
}
.contentbox .show{
  width: 94vw;
  margin: auto;
  margin-top: 4vw;
  padding-bottom: 5.333vw;
  /* height: 965px; */
  overflow: hidden;
}
.show h1{
padding-top: 6.133vw;
padding-left: 4.533vw;
height: 4.267vw;
font-size: 4.267vw;
font-family: PingFang SC;
font-weight: bold;
color: #2E8EEB;
line-height: 4.267vw;
}
.personInfo{
  width:94vw;
  margin: auto;
  margin-top: 16px;
  font-size: 24px;
  border-collapse:collapse;
  border-spacing:0;
  
}
.personInfo td{
  border-bottom: 1px dashed #EDF0F6; 
  /* padding:5px 15px; */
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  text-align: center;
}
.personInfo tr td:nth-child(2n-1){
  width: 97px;
}
.personInfo tr td:nth-child(2n){
  width: 290px;
}
.theader{
  text-align: center;
  font-weight: bold;
  color: #0157C6;
  line-height: 28px;
}
.personInfo .title td:nth-child(2n-1){
  width: 25%;
    height: 60px;
    text-align: center;
    padding: 0;
    line-height: 60px;
    color: red;
}
.personInfo .title td:nth-child(2n){
  width: 25%;
    height: 60px;
    text-align: center;
    padding: 0;
    line-height: 60px;
    color: red;
}

.personInfo .date td:nth-child(2n-1){
    height: 30px;
    text-align: center;
    padding: 0;
    line-height: 30px;
    color: red;
}
.personInfo .date td:nth-child(2n){
    text-align: center;
    padding: 0;
    height: 30px;
    line-height: 30px;
    color: red;
}
.result{
  position: relative;
  width: 100vw;
  height: 44.933vw;
  background-color: #FFFFFF;
}
.result h2{
  position: relative;
  padding:10.267vw 0 13.067vw;
height: 4.667vw;
font-size: 4.667vw;
font-family: PingFang SC;
font-weight: bold;
color: #333333;
line-height: 4.667vw;
text-align: center;
}
.result h2::after{
  position: absolute;
  content:'';
  left:47.467vw;
  bottom: 8.133vw;
width: 4.933vw;
height: 1.067vw;
background: #2E8EEB;
border-radius: 0.4vw;
}
.result div{
  position: relative;
  width: 81vw;
  padding-left: 12.667vw;
  margin: auto;
height: 12.8vw;
background: #FFEEED;
font-size: 3.2vw;
font-family: PingFang SC;
font-weight: 500;
color: #F24040;
line-height: 4.8vw;
display: flex;
justify-content: start;
align-items: center;
background-image: url(/static/img/img/reccet.png);
background-repeat: no-repeat;
background-size: 5.067vw 5.067vw;
background-position: 4.8vw center;
}
</style>